import '@babel/polyfill';
import './index.scss';
import Game from './game';

const game = new Game();
game.start();
